export default __webpack_public_path__ + "static/Content-image-514199a86a80886fde967bcf5ba3bca1.webp";